import { useProjectStore } from '../projectStore';

/**
 * ProjectDataContextのuseProjectDataと互換性のあるフック
 * 既存のコードからの移行を簡単にする
 */
export const useProjectData = () => {
  // プロジェクトとデータセットを取得
  const project = useProjectStore(state => state.project);
  const datasets = useProjectStore(state => state.datasets);
  const reports = useProjectStore(state => state.reports);
  
  // アクションを取得（これらは変更されないのでshallow比較不要）
  const updateProject = useProjectStore(state => state.updateProject);
  const addDataset = useProjectStore(state => state.addDataset);
  const updateDataset = useProjectStore(state => state.updateDataset);
  const removeDataset = useProjectStore(state => state.removeDataset);
  const addDerivedDataset = useProjectStore(state => state.addDerivedDataset);
  const getDataset = useProjectStore(state => state.getDataset);
  const getAllDatasets = useProjectStore(state => state.getAllDatasets);
  
  // 既存のProjectDataContextと互換性のあるインターフェースを返す
  return {
    project,
    datasets,
    reports,
    updateProject,
    addDataset,
    updateDataset,
    removeDataset,
    addDerivedDataset,
    getDataset,
    getAllDatasets
  };
};

/**
 * 単一のデータセットを取得するためのフック
 * パフォーマンス最適化のため、特定のデータセットのみを監視
 */
export const useDataset = (datasetId: string | undefined) => {
  const dataset = useProjectStore(
    state => datasetId ? state.getDataset(datasetId) : undefined
  );
  
  return dataset;
};

/**
 * プロジェクトの基本情報のみを取得するフック
 */
export const useProject = () => {
  const project = useProjectStore(state => state.project);
  const updateProject = useProjectStore(state => state.updateProject);
  
  return {
    project,
    updateProject
  };
};